import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
} from "react-native";
import Slider from "app/components/Slider";
import Text from "app/components/Text";
import valueActions from "app/utils/valueActions";
import prefActions from "app/utils/prefActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import timeHelpers from "app/utils/timeHelpers";
import filterHelpers from "app/utils/filterHelpers";
import {
  styleSheet,
  colors,
  sizes,
  screenRatio,
  HEIGHT,
} from "app/utils/styleSheet";
import HoverableTooltip from "app/components/HoverableTooltip";

// import Toast from "react-native-root-toast";
import DatePicker from "app/components/DatePicker";
import Autocomplete from "app/components/Autocomplete";

import store from "app/redux/store";
import { setFilter, setFilters } from "app/actions/filters";

import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
  Foundation,
  SimpleLineIcons,
  AntDesign,
  FontAwesome5,
} from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class FilterBar extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    hideQuery: PropTypes.bool,
    hideCreate: PropTypes.bool,
    levelButtons: PropTypes.bool,
    // level: PropTypes.number,
    temporary: PropTypes.bool,
    chunkFactor: PropTypes.number,
  };

  static defaultProps = {
    chunkFactor: 1,
  };

  constructor(props) {
    super(props);
    // let { user } = props.screenProps
    // props.navigation

    let { preferences, filters, app } = store.getState();
    let { loading, datetime } = app;

    let { temporary } = props;
    if (temporary) {
      filters = props.filters || filterHelpers.defaultFilters();
    }

    this.state = {
      loading,
      preferences,
      filters,
      query: "",
      datetime,
      expandFilters: ENV.WEB && !props.hideFilters,
      // showDatePicker: !!datetime,
      showDatePicker: true,
      autoProgressing: false,
      showDropDown: false,
    };
  }

  async componentDidMount() {
    this.subscribe();
    // focus
    // if (ENV.WEB) window.addEventListener("focus", this.subscribe);
    // if (ENV.WEB) window.addEventListener("blur", this.unsubscribe);
    // this.unsubscribeFocus = this.props.navigation?.addListener(
    this.unsubscribeFocus = await RootNavigation.addListener(
      "focus",
      this.subscribe,
    );
    // this.unsubscribeBlur = this.props.navigation?.addListener(
    this.unsubscribeBlur = await RootNavigation.addListener(
      "blur",
      this.unsubscribe,
    );
  }

  componentWillUnmount() {
    // if (ENV.WEB) window.removeEventListener("focus", this.subscribe);
    // if (ENV.WEB) window.removeEventListener("blur", this.unsubscribe);
    this.unsubscribeBlur && this.unsubscribeBlur();
    this.unsubscribeFocus && this.unsubscribeFocus();
    this.unsubscribe && this.unsubscribe();
  }

  subscribe = async () => {
    let { temporary, hideFilters } = this.props;
    let filters;
    if (temporary || hideFilters) {
      filters = this.props.filters || filterHelpers.defaultFilters();
    } else {
      filters = await storageActions.fetchItem(
        "filters",
        filterHelpers.defaultFilters(),
      );
    }
    console.log(filters, store.getState().filters);
    store.dispatch(setFilters(filters, temporary));
    // this.setState({ loading: false });

    // let { filters, onUpdateFilter } = this.props
    // if(!!filters?.length){
    //   let pref = await prefActions.get()
    //   filters = pref.filters
    //   await this.setState({...filters})
    // }
    // onUpdateFilter && onUpdateFilter('showFocus', filters.showFocus)

    if (ENV.WEB && !this.props.noAutoFocus) this.focusInput();

    this.unsubscribeRedux = store.subscribe(() => {
      let { app, preferences, filters } = store.getState();
      let { loading, datetime } = app;

      let showDatePicker = this.state.showDatePicker;
      if (datetime != this.state.datetime) {
        showDatePicker = true;
      }

      this.setState({
        loading,
        preferences,
        filters,
        datetime,
        showDatePicker,
      });
    });
  };

  unsubscribe = () => {
    this.unsubscribeRedux && this.unsubscribeRedux();
  };

  focusInput = () => {
    if (this.filterInput) {
      this.filterInput.focus();
    }
  };

  async componentDidUpdate(prevProps, prevState) {
    // // this.setState({...this.props})
    // let filtersChanged = false
    // Object.keys(this.props).forEach(key => {
    //   if(this.props[key] != this.state[key]){
    //     filtersChanged = true
    //   }
    // })
    // if(filtersChanged){
    //   console.log(this.props)
    //   console.warn('updating filters')
    //   this.setState({...this.props})
    // }
  }

  render() {
    let {
      onFetch,
      onUpdate,
      hideQuery,
      hideCreate,
      levelButtons,
      style,
      hidePrompts,
      scale,
      onUpdateScale,
      chunkFactor,
      temporary,
      hideFilters,
    } = this.props;
    let { loading, filters, datetime, autoProgressing } = this.state;
    let { query, level, expandFilters, showDatePicker, showDropDown } =
      this.state;

    let {
      showComplete,
      hideDoneToday,
      showHidden,
      showSnoozed,
      showFocus,
      showNotes,
      showPrompts,
      showRipe,
      showArchived,
      showSubTasks,
      fromBottom,
    } = filters;

    let buttonColorOptions = [
      this.context.colors.trim,
      this.context.colors.active,
      this.context.colors.activeHighlight,
    ];

    return (
      <View horizontal style={{ zIndex: 2 }}>
        <View style={[this.styles().row, this.styles().outterRow, style]}>
          <View style={this.styles().row}>
            {loading ? (
              <ActivityIndicator style={this.styles().icon} />
            ) : (
              <TouchableOpacity
                onPress={() => valueActions.indexLite()}
                style={[this.styles().icon]}
              >
                <Ionicons
                  name="refresh"
                  size={this.context.sizes.itemHeight}
                  color={this.context.colors.foreground}
                />
              </TouchableOpacity>
            )}

            {!hideQuery && (
              <View>
                <View style={{ flexDirection: "row" }}>
                  <TextInput
                    ref={(c) => (this.filterInput = c)}
                    onKeyPress={this.handleKeyPress}
                    style={this.styles().input}
                    placeholderTextColor={this.context.colors.placeholder}
                    value={query}
                    placeholder={"search"}
                    onChangeText={async (query) => {
                      await this.setState({ query });
                      !!onUpdate && onUpdate();
                      !!this.props.onUpdateQuery &&
                        this.props.onUpdateQuery(query);
                    }}
                  />
                </View>
                {showDropDown && (
                  <View style={{ position: "absolute", top: "100%" }}>
                    <Autocomplete
                      placeholder={"value name"}
                      suggestionsOnly
                      // placeholderTextColor={placeholderColor}
                      // extraStyle={inputStyle}
                      // onFocus={() => this.setState({focusedField: 'name'})}
                      // data={focusedField == 'name' ? suggestions : []}
                      // defaultValue={value.name || ''}
                      query={query}
                      // data={textHelpers.suggestions(
                      //   query,
                      //   valueHelpers.filterToCurrentRevisions(
                      //     store.getState().values
                      //   )
                      // )}
                      onChangeText={(text) => {
                        this.setState({ query: text });
                      }}
                      simpleListView
                      onSelectItem={(value, event) => {
                        RootNavigation.push("Value", { id: value.id }, event);
                      }}
                      // renderItem={({ item, i }) => (
                      //   <TouchableOpacity
                      //     key={i}
                      //     onPress={() => {
                      //       this.setState({ query: "", showDropDown: false });
                      //       // console.log(item)
                      //       RootNavigation.push("Value", { id: item.id });
                      //     }}
                      //   >
                      //     <Text>{item.text}</Text>
                      //   </TouchableOpacity>
                      // )}
                    />
                  </View>
                )}
              </View>
            )}
            {!hideQuery && !!query.length && (
              <Feather
                name={`chevron-${showDropDown ? "up" : "down"}`}
                size={this.context.sizes.itemHeight}
                color={this.context.colors.foreground}
                onPress={() => this.setState({ showDropDown: !showDropDown })}
              />
            )}
            {!hideQuery && !!query?.length && (
              <Feather
                name="x"
                size={this.context.sizes.itemHeight}
                color={this.context.colors.foreground}
                onPress={() => {
                  this.setState({ query: "", showDropDown: false });
                  // !!onUpdate && onUpdate()
                  // !!this.props.onUpdateQuery && this.props.onUpdateQuery('', true)
                }}
              />
            )}

            {false && (
              <View
                style={[
                  this.styles().row,
                  {
                    justifyContent: "flex-start",
                    marginLeft: this.context.sizes.base,
                  },
                ]}
              >
                {showDatePicker ? (
                  <View
                    style={[
                      this.styles().row,
                      { flex: -1, justifyContent: "flex-start" },
                    ]}
                  >
                    <TouchableOpacity
                      style={this.styles().icon}
                      onPress={this.previousTime}
                    >
                      <AntDesign
                        name="left"
                        size={this.context.sizes.itemHeight}
                        color={this.context.colors.foreground}
                      />
                    </TouchableOpacity>
                    <DatePicker
                      // placeholderTextColor={placeholderColor}
                      selected={!!datetime ? new Date(datetime) : new Date()}
                      // value={!!datetime ? new Date(datetime) : new Date()}
                      onSelect={(d) => {
                        console.log("selected", d);
                      }}
                      onChange={(d) => {
                        this.setTime(d);
                        // console.log(d)
                        // store.dispatch({type: 'app/datetime', datetime: d.toString()})
                        // this.showToast({message: textHelpers.formatDate(d), position: HEIGHT*0.75})
                      }}
                    />
                    <TouchableOpacity
                      style={this.styles().icon}
                      onPress={this.nextTime}
                    >
                      <AntDesign
                        name="right"
                        size={this.context.sizes.itemHeight}
                        color={this.context.colors.foreground}
                      />
                    </TouchableOpacity>
                  </View>
                ) : (
                  <Text onPress={() => this.setState({ showDatePicker: true })}>
                    Change timeframe
                  </Text>
                )}
                {showDatePicker &&
                  (!autoProgressing ? (
                    <FontAwesome
                      name="play"
                      size={this.context.sizes.itemHeight}
                      color={this.context.colors.foreground}
                      onPress={this.autoProgress}
                    />
                  ) : (
                    <FontAwesome
                      name="pause"
                      size={this.context.sizes.itemHeight}
                      color={this.context.colors.foreground}
                      onPress={() => this.setState({ autoProgressing: false })}
                    />
                  ))}
                {showDatePicker && !!datetime && (
                  <Text
                    onPress={() => {
                      store.dispatch({
                        type: "app/datetime",
                        datetime: new Date().toString(),
                      });
                      // this.setState({ showDatePicker: false });
                      this.showToast({
                        message: textHelpers.formatDate(new Date()),
                        position: HEIGHT * 0.75,
                      });
                    }}
                  >
                    {` now`}
                  </Text>
                )}
              </View>
            )}

            {levelButtons && this.renderLevelButtons()}
          </View>

          {expandFilters && (
            <ScrollView
              horizontal
              contentContainerStyle={[
                this.styles().row,
                { justifyContent: "flex-end" },
              ]}
              style={[
                // this.styles().row,
                {
                  // justifyContent: 'flex-end',
                  paddingRight: ENV.WEB ? undefined : 0,
                  // borderWidth: 1, borderColor: 'white',
                },
              ]}
            >
              {temporary && <Text>Temp</Text>}

              <HoverableTooltip text="Reset Filters" rightInline>
                <TouchableOpacity
                  onPress={this.resetFilters}
                  style={this.styles().icon}
                >
                  <MaterialCommunityIcons
                    name="restart"
                    size={this.context.sizes.itemHeight}
                    color={buttonColorOptions[0]}
                  />
                </TouchableOpacity>
              </HoverableTooltip>

              {ENV.DEMO && !hidePrompts && (
                <TouchableOpacity
                  onPress={() => this.cycleOption("showPrompts")}
                  style={this.styles().icon}
                >
                  <MaterialCommunityIcons
                    name="clippy"
                    size={this.context.sizes.itemHeight}
                    color={buttonColorOptions[showPrompts]}
                  />
                </TouchableOpacity>
              )}

              <HoverableTooltip text="Toggle Notes" rightInline>
                <TouchableOpacity
                  onPress={() => this.cycleOption("showNotes")}
                  style={this.styles().icon}
                >
                  <FontAwesome5
                    name={"sticky-note"}
                    size={this.context.sizes.itemHeight}
                    color={buttonColorOptions[showNotes]}
                  />
                </TouchableOpacity>
              </HoverableTooltip>

              <HoverableTooltip text="Toggle Focus" rightInline>
                <TouchableOpacity
                  onPress={() => this.cycleOption("showFocus")}
                  style={this.styles().icon}
                >
                  <SimpleLineIcons
                    name={"target"}
                    size={this.context.sizes.itemHeight}
                    color={buttonColorOptions[showFocus]}
                  />
                </TouchableOpacity>
              </HoverableTooltip>

              <HoverableTooltip text="Toggle Complete" rightInline>
                <TouchableOpacity
                  onPress={() => this.cycleOption("showComplete")}
                  style={this.styles().icon}
                >
                  <Feather
                    name={"check-circle"}
                    size={this.context.sizes.itemHeight}
                    color={buttonColorOptions[showComplete]}
                  />
                </TouchableOpacity>
              </HoverableTooltip>

              <HoverableTooltip text="Flip Hierarchy" rightInline>
                <TouchableOpacity
                  onPress={() => this.cycleOption("fromBottom")}
                  style={this.styles().icon}
                >
                  <Entypo
                    name="flow-tree"
                    size={this.context.sizes.itemHeight}
                    color={
                      fromBottom
                        ? this.context.colors.trim
                        : this.context.colors.active
                    }
                    style={
                      fromBottom ? null : { transform: [{ rotateZ: "180deg" }] }
                    }
                  />
                </TouchableOpacity>
              </HoverableTooltip>

              {!ENV.DEMO && (
                <HoverableTooltip text="Toggle Snoozed" rightInline>
                  <TouchableOpacity
                    onPress={() => this.cycleOption("showSnoozed")}
                    style={this.styles().icon}
                  >
                    <FontAwesome
                      name="moon-o"
                      size={this.context.sizes.itemHeight}
                      color={buttonColorOptions[showSnoozed]}
                    />
                  </TouchableOpacity>
                </HoverableTooltip>
              )}

              {!ENV.DEMO && (
                <HoverableTooltip text="Toggle Done Today" rightInline>
                  <TouchableOpacity
                    onPress={() => this.cycleOption("hideDoneToday")}
                    style={this.styles().icon}
                  >
                    <FontAwesome
                      name={"calendar-times-o"}
                      size={this.context.sizes.itemHeight - 4}
                      color={buttonColorOptions[hideDoneToday]}
                    />
                  </TouchableOpacity>
                </HoverableTooltip>
              )}

              {!ENV.DEMO && (
                <HoverableTooltip text="Toggle Hidden" rightInline>
                  <TouchableOpacity
                    onPress={() => this.cycleOption("showHidden")}
                    style={this.styles().icon}
                  >
                    <Ionicons
                      name="eye-off"
                      size={this.context.sizes.itemHeight - 4}
                      color={buttonColorOptions[showHidden]}
                    />
                  </TouchableOpacity>
                </HoverableTooltip>
              )}

              {!ENV.DEMO && (
                <HoverableTooltip text="Toggle Archived" rightInline>
                  <TouchableOpacity
                    onPress={() => this.cycleOption("showArchived")}
                    style={this.styles().icon}
                  >
                    <Feather
                      name="archive"
                      size={this.context.sizes.itemHeight - 4}
                      color={buttonColorOptions[showArchived]}
                    />
                  </TouchableOpacity>
                </HoverableTooltip>
              )}

              {ENV.WEB && (
                <HoverableTooltip text="Toggle Ripe" rightInline>
                  <TouchableOpacity
                    onPress={() => this.cycleOption("showRipe")}
                    style={this.styles().icon}
                  >
                    <MaterialCommunityIcons
                      name="gauge-full"
                      size={this.context.sizes.itemHeight}
                      color={buttonColorOptions[showRipe]}
                    />
                  </TouchableOpacity>
                </HoverableTooltip>
              )}

              <HoverableTooltip text="Toggle Sub-Tasks" rightInline>
                <TouchableOpacity
                  onPress={() => this.cycleOption("showSubTasks")}
                  style={this.styles().icon}
                >
                  <MaterialCommunityIcons
                    name="sitemap"
                    size={this.context.sizes.itemHeight - 4}
                    color={buttonColorOptions[showSubTasks]}
                  />
                </TouchableOpacity>
              </HoverableTooltip>

              {/*!hideCreate && (
                <HoverableTooltip text="Create Item" rightInline>
                  <TouchableOpacity
                    onPress={() => RootNavigation.navigate("Create")}
                    style={this.styles().icon}
                  >
                    <Ionicons
                      name="add-circle-outline"
                      size={this.context.sizes.itemHeight}
                      color={this.context.colors.foreground}
                    />
                  </TouchableOpacity>
                </HoverableTooltip>
              )*/}
            </ScrollView>
          )}

          {!ENV.WEB && !hideFilters && (
            <View
              style={[
                this.styles().row,
                { justifyContent: "flex-end", paddingLeft: 0 },
              ]}
            >
              <TouchableOpacity
                onPress={() => this.setState({ expandFilters: !expandFilters })}
                style={this.styles().icon}
              >
                <Feather
                  name="filter"
                  size={this.context.sizes.itemHeight}
                  color={buttonColorOptions[expandFilters ? 1 : 0]}
                />
              </TouchableOpacity>
            </View>
          )}
        </View>
        {!ENV.WEB && expandFilters && !!scale && (
          <View style={[this.styles().row, { paddingHorizontal: 80 }]}>
            <Slider
              style={[this.styles().row]}
              // onSlidingComplete={val => alert(val)}
              value={scale}
              // onValueChange={val => onUpdateScale(val)}
              onSlidingComplete={(val) => onUpdateScale(val)}
              minimumValue={0.1}
              maximumValue={1.0}
              minimumTrackTintColor={this.context.colors.active}
            />
          </View>
        )}
      </View>
    );
  }

  renderLevelButtons = () => {
    let { level, topLevel, onChangeLevel } = this.props;
    level = parseInt(level);
    let { onUpdate, onUpdateFilter } = this.props;
    return (
      <View style={{ flexDirection: "row" }}>
        <TouchableOpacity
          style={this.styles().icon}
          onLongPress={async () => {
            if (level < topLevel) {
              // this.showToast('jumping to top level')
              // await this.setState({level: topLevel})
              // !!onUpdate && onUpdate()
              !!onUpdateFilter && onUpdateFilter("level", topLevel);
            }
          }}
          onPress={async () => {
            if (level < topLevel) {
              // this.showToast('going up one level')
              // await this.setState({level: Math.min(topLevel, level+1)})
              // !!onUpdate && onUpdate()
              !!onUpdateFilter && onUpdateFilter("level", level + 1);
            }
          }}
        >
          <Feather
            name={"chevrons-up"}
            size={this.context.sizes.itemHeight}
            color={
              level < topLevel
                ? this.context.colors.foreground
                : this.context.colors.trim
            }
          />
        </TouchableOpacity>
        <View style={[this.styles().icon, this.styles().levelWrapper]}>
          <Text>{!!level || level === 0 ? level : ""}</Text>
        </View>
        <TouchableOpacity
          style={this.styles().icon}
          onLongPress={async () => {
            if (level > 0) {
              // this.showToast('jumping to bottom level')
              // await this.setState({level: 0})
              // !!onUpdate && onUpdate()
              !!onUpdateFilter && onUpdateFilter("level", 0);
            }
          }}
          onPress={async () => {
            if (level > 0) {
              // this.showToast('going down one level')
              // await this.setState({level: Math.max(0, level-1)})
              // !!onUpdate && onUpdate()
              !!onUpdateFilter && onUpdateFilter("level", level - 1);
            }
          }}
        >
          <Feather
            name={"chevrons-down"}
            size={this.context.sizes.itemHeight}
            color={
              level > 0
                ? this.context.colors.foreground
                : this.context.colors.trim
            }
          />
        </TouchableOpacity>
      </View>
    );
  };

  cycleOption = async (option) => {
    let { onUpdate, onUpdateFilter, temporary } = this.props;
    let { filters } = this.state;

    let trinaryOptions = [
      "showSnoozed",
      "hideDoneToday",
      "showHidden",
      "showComplete",
      "showArchived",
      "showNotes",
    ];
    let scopingOptions = ["showRipe", "showFocus"];

    let possibleModes = 2;
    if (trinaryOptions.includes(option)) {
      possibleModes = 3;
    }

    // let value = this.state[option]
    let value = filters[option];
    value += 1;
    if (value > possibleModes - 1) value = 0;
    // value -= 1
    // if(value < 0) value = possibleModes-1

    let exclusiveVerbs = ["hiding", "showing", "showing only"];
    let inclusiveVerbs = ["showing", "hiding", "showing only"];

    let verbs = exclusiveVerbs;
    if (option.startsWith("hide")) {
      verbs = inclusiveVerbs;
    }

    let nouns = {
      showSnoozed: "snoozed items",
      hideDoneToday: "items progressed today",
      showHidden: "hidden items",
      showComplete: "completed items",
      showFocus: "focus items",
      showNotes: "notes",
      showPrompts: "prompts",
      showRipe: "ripe items",
      showArchived: "archived items",
      showSubTasks: "sub-tasks",
    };
    let message = `${verbs[value]} ${nouns[option]}`;

    // special cases
    if (option == "fromBottom") {
      message = `${value ? "Bottom" : "Top"} level alignment`;
    }

    if (scopingOptions.includes(option)) {
      if (value == 0)
        message = `removing "${nouns[option].split(" ")[0]}" scope`;
      else message = `scoping to ${nouns[option]}`;
    }

    this.showToast({ message });

    // await this.setState({[option]: value})
    // filters[option] = value

    // console.log('state filters updated')
    !!onUpdateFilter && onUpdateFilter(option, value);
    !!onUpdate && onUpdate();

    let persistentFilters = {};
    let defaultFilters = filterHelpers.defaultFilters();
    Object.keys(defaultFilters).forEach((key) => {
      // persistentFilters[key] = this.state[key]
      // persistentFilters[key] = filters[key]
    });

    // store.dispatch(setFilters(filters, temporary))
    store.dispatch(setFilter(option, value, temporary));
    this.props.onChangeFilters && this.props.onChangeFilters();
  };

  showToast = ({ message, position = 150, animation = true }) => {
    // if (this.toast) Toast.hide(this.toast);
    // this.toast = Toast.show(message, {
    //   duration: Toast.durations.LONG,
    //   // position: Toast.positions.TOP,
    //   position,
    //   shadow: true,
    //   animation,
    //   hideOnPress: true,
    //   backgroundColor: this.context.colors.foreground,
    //   textColor: this.context.colors.empty,
    //   delay: 0,
    //   onShow: () => {
    //     // calls on toast\`s appear animation start
    //   },
    //   onShown: () => {
    //     // calls on toast\`s appear animation end.
    //   },
    //   onHide: () => {
    //     // calls on toast\`s hide animation start.
    //   },
    //   onHidden: () => {
    //     // calls on toast\`s hide animation end.
    //   },
    // });
  };

  handleKeyPress = (event) => {
    // console.log('keypress:', event.keyCode, event.keyValue)
    let triggerKey = false;
    // 13 == enter
    // 9 == tab
    if (event.keyCode == 9) {
      return;
      event.preventDefault();
      // console.log('tab')
      if (this.state.shiftIsDown) {
        // console.log('unindent!')
        // this.handleUnindentItem(item)
      } else {
        // this.handleIndentItem(item)
      }
    } else if (event.keyCode == 13) {
      event.preventDefault();
      // console.log('enter')
      // this.handleAppendItem(item)
      this.setState({ showDropDown: true });
    } else if (event.keyCode == 8) {
      // console.log('backspace')
      // if(item.text == ''){
      // this.handleDeleteItem(item)
      // }
    } else if (event.keyCode == 16) {
      // console.log('shift down')
      this.setState({ shiftIsDown: true });
      triggerKey = true;
    } else if (event.keyCode == 27) {
      // console.log('escape')
      this.setState({ query: "" });
    }
    // 38 // up
    // 39 // right
    // 40 // down
    // 37 // left
    if (!triggerKey) {
      this.setState({ shiftIsDown: false });
    }
  };

  autoProgress = () => {
    this.setState({ autoProgressing: true });
    let { datetime } = this.state;
    setTimeout(() => {
      if (this.state.autoProgressing) {
        // let newDatetime = new Date(datetime)
        // newDatetime.setDate(newDatetime.getDate()+1)
        this.nextTime();
        // store.dispatch({type: 'app/datetime', datetime: newDatetime.toString()})
        // this.showToast({message: textHelpers.formatDate(newDatetime), position: HEIGHT*0.75, animation: false})
        this.autoProgress();
      }
    }, 200);
  };

  resetFilters = async () => {
    let { onUpdate, temporary } = this.props;
    let confirm = await valueActions.confirm("reset", "", "Reset filters?");
    if (!confirm) return;
    let defaultFilters = this.props.filters || filterHelpers.defaultFilters();
    store.dispatch(setFilters(defaultFilters, temporary));
  };

  previousTime = () => {
    let { datetime } = this.state;
    let { chunk } = this.props;
    let d = datetime ? new Date(datetime) : new Date();
    let chunkFactor = chunk == "month" ? 30 : chunk == "week" ? 7 : 1;
    let newDate;
    if (chunk == "month") {
      newDate = new Date(d);
      newDate.setMonth(d.getMonth() - 1);
    } else {
      newDate = new Date(d.getTime() - timeHelpers.msInDay * chunkFactor);
    }
    this.setTime(newDate);
  };

  nextTime = () => {
    let { datetime } = this.state;
    let { chunk } = this.props;
    let d = datetime ? new Date(datetime) : new Date();
    let chunkFactor = chunk == "month" ? 30 : chunk == "week" ? 7 : 1;
    let newDate;
    if (chunk == "month") {
      newDate = new Date(d);
      newDate.setMonth(d.getMonth() + 1);
    } else {
      newDate = new Date(d.getTime() + timeHelpers.msInDay * chunkFactor);
    }
    this.setTime(newDate);
    this.props.autoProgress && this.props.autoProgress();
  };

  setTime = (date) => {
    let { chunk } = this.props;
    date = new Date(date);

    let message = textHelpers.formatDate(date);
    if (chunk == "week") {
      message = `${textHelpers.formatDate(
        timeHelpers.beginningOfWeek(date),
      )} - ${textHelpers.formatDate(timeHelpers.endOfWeek(date))}`;
    } else if (chunk == "month") {
      message = `${textHelpers.formatDate(
        timeHelpers.beginningOfMonth(date),
      )} - ${textHelpers.formatDate(timeHelpers.endOfMonth(date))}`;
    }
    // this.showToast({message, position: HEIGHT*0.75})

    store.dispatch({ type: "app/datetime", datetime: date.toString() });
  };

  styles = () => ({
    outterRow: {
      flexGrow: 0,
      height: 50,
      padding: this.context.sizes.base,
      justifyContent: "space-between",
    },
    row: {
      flexGrow: 1,
      alignSelf: "stretch",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    input: {
      ...styleSheet.input,
      alignSelf: "stretch",
      flex: 1,
    },
    icon: {
      // marginLeft: this.context.sizes.base,
      marginHorizontal: this.context.sizes.base,
      minWidth: this.context.sizes.base,
      minHeight: this.context.sizes.base,
      alignSelf: "center",
      // borderWidth: 1, borderColor: 'white',
    },
    levelWrapper: {
      borderBottomWidth: 1,
      borderColor: this.context.colors.trim,
      paddingBottom: this.context.sizes.small,
    },
  });
}
